import { AnswerDto, Category, Checklist, Question } from "../../checklist/model/ChecklistDtos";

export interface QualityCheckDto {
    idQualityCheck: number;
    scheduledOn: string;
    checkStarted: string | null;
    checkEnded: string | null;
    inspectorName: string | null;
    remarks: string | null;
    state: number;
    noOfQuestions: number;
    noOfQuestionsAnswered: number;
    checklist: Checklist;
}

export interface QualityCheckDetailDto {
    idQualityCheck: number;
    scheduledOn: string;
    checkStarted: string | null;
    checkEnded: string | null;
    inspectorName: string | null;
    remarks: string | null;
    state: number;
    noOfQuestions: number;
    noOfQuestionsAnswered: number;
    checklist: Checklist;
    answers: AnswerDto[];
}

export interface QuestionAnswerDto {
    category: Category;
    question: Question;
    answer?: AnswerDto;
}

export enum QualityCheckStatus {
    Expired,
    Finished,
    Active,
    Scheduled
}
